import getAmplifyConfig from '@src/modules/auth/amplify/amplify-config'

import { setInLocalStorageWithExpiry } from '../utils/setInLocalStorageWithExpiry'

/**
 * @warning This function is only used for native webview sessions
 */
export async function getCognitoTokensFromRT(refreshToken: string) {
  if (!refreshToken) throw new Error('Refresh token not found')

  const config = getAmplifyConfig()

  if (!config) throw new Error('Amplify config not found')

  const AWS_REGION = config.aws_cognito_region
  const AWS_CLIENT_ID = config.aws_user_pools_web_client_id

  const jwtTokenStr = await fetch('https://cognito-idp.' + AWS_REGION + '.amazonaws.com/', {
    headers: {
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
      'Content-Type': 'application/x-amz-json-1.1',
    },
    mode: 'cors',
    cache: 'no-cache',
    method: 'POST',
    body: JSON.stringify({
      ClientId: AWS_CLIENT_ID,
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      AuthParameters: {
        REFRESH_TOKEN: refreshToken,
      },
    }),
  })

  if (jwtTokenStr.status >= 200 && jwtTokenStr.status < 400) {
    // : { AuthenticationResult: {AccessToken: string; ExpiresIn: number; IdToken: string; TokenType: string}; ChallengeParameters: {}; }
    const tokenObj = await jwtTokenStr.json()

    const { IdToken, AccessToken } = tokenObj.AuthenticationResult

    setInLocalStorageWithExpiry('native_session_tokens', JSON.stringify({ IdToken, AccessToken }), 23 * 60)

    return { IdToken, AccessToken }
  } else {
    const res = await jwtTokenStr.json()
    const err = new Error(res.message)
    err.name = res.__type
    throw err
  }
}
